export enum ValidationType {
    invalid = 0,
    valid = 1,
    warning = 2,
    empty = 4,
}